export default "__VITE_ASSET__6e00ff87__"